import type { ReactNode } from 'react'

/** The small uppercase rule that heads each block of wedding detail. */
export function SectionHeading({ id, children }: { id: string; children: ReactNode }) {
  return (
    <h2
      id={id}
      className="text-ink-soft border-ink/10 border-b pb-2 text-xs tracking-[0.25em] uppercase"
    >
      {children}
    </h2>
  )
}
